import $ from "jquery"
import slider from "slick-carousel"


function set_value(select, slides) {
    const year = select.find("option:selected").val();
    console.log(select, slides, year)
    const active_slide = slides.filter(function (_, el) {
        return year == $(el).data("value")
    });
    slides.removeClass('active');
    active_slide.addClass('active');
}

function InitSelectSliders() {
    const sliders = $(".category_filter_select_year_slider");
    console.log(sliders)
    $.each(sliders, function (slider_number, slider) {
        const slides = $(slider).find(".category_filter_select_year_slider_wrap");
        const select = $(slider).find("select");
        const form = $(slider).parent()

        // var slider_action = $(slider).find('.slider');
        // var years = [];
        // $.each(slides, function (slides_number, slide) {
        //     years.push($(slide).data("year"))
        // });
        // console.log(years);

        $(slides).slick({
            arrows: false,
            infinite: false,
            speed: 500,
            // centerPadding: '20%',
            // initialSlide: 3,
            mobileFirst: true,
            slidesToShow: 2,
            // variableWidth: true,
            centerMode: true,
            // row: 6,
            responsive: [
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                    }
                }, {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerPadding: '-30%',
                        centerMode: $(slides).find("[data-value]").length < 8,
                    }
                }, {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        centerPadding: '-30%',
                        centerMode: $(slides).find("[data-value]").length < 8,
                    }
                }, {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        centerPadding: '-30%',
                        centerMode: $(slides).find("[data-value]").length < 8,
                    }
                }
            ]
        })
        const slides_data = $(slides).find("[data-value]")

        set_value($(this), slides_data);
        select.on('change', function () {
            set_value($(this), slides_data);
        })
        slides_data.on("click", function () {
            select.val($(this).data("value"));
            set_value(select, slides_data);
            form.submit();
        })
    });
}

export {
    InitSelectSliders,
}
